import { Box } from '@mui/material';
import { PromptGroup } from '@server/prompts';
import { PromptCard } from './promptGroupCard/PromptCard';

interface PromptGroupsListProps {
  promptGroups: PromptGroup[];
  onPromptCardClick: (prompt: PromptGroup) => void;
}

export const PromptGroupsList = ({ promptGroups, onPromptCardClick }: PromptGroupsListProps) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '24px',
        width: '100%',
        justifyItems: 'center',
      }}
    >
      {promptGroups.map((group) => (
        <PromptCard
          key={group.id}
          promptGroup={group}
          onClick={onPromptCardClick}
          isMinimized={false}
        />
      ))}
    </Box>
  );
};
